import React, { memo } from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

const ReplyDoubleArrowIcon = ({ className, width, height }) => {
  const classes = useStyles();

  return (
    <SvgIcon
      sx={{ width: width, height: height }}
      className={clsx(classes.icon, className)}
      viewBox="0 -960 960 960"
      fill="currentColor"
    >
      <path d="M320-280 80-520l240-240 57 56-184 184 184 184-57 56Zm480 80v-160q0-50-35-85t-85-35H433l144 144-57 56-240-240 240-240 57 56-144 144h247q83 0 141.5 58.5T880-360v160h-80Z" />
    </SvgIcon>
  );
};
ReplyDoubleArrowIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
ReplyDoubleArrowIcon.defaultProps = {
  width: 24,
  height: 24,
};
export default memo(ReplyDoubleArrowIcon);

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.primary.main,
  },
}));
